'use client'

import { useCallback, useEffect, useState } from 'react'

const LANGUAGE_STORAGE_KEY = 'docs:language'

export function useDocumentationLanguage(availableLanguages: string[]) {
  const [selectedLanguage, setSelectedLanguageState] = useState<string | null>(null)

  useEffect(() => {
    if (availableLanguages.length === 0) return

    try {
      const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY)
      const initial = stored && availableLanguages.includes(stored) ? stored : availableLanguages[0]!
      setSelectedLanguageState(initial)
    } catch {
      setSelectedLanguageState(availableLanguages[0]!)
    }
  }, [availableLanguages])

  const setSelectedLanguage = useCallback((lang: string) => {
    setSelectedLanguageState(lang)
    try {
      localStorage.setItem(LANGUAGE_STORAGE_KEY, lang)
    } catch {
      // localStorage unavailable
    }
  }, [])

  return { selectedLanguage, setSelectedLanguage }
}
